import XhrRequestHandler from '../../lib/XhrRequestHandler';
import { TipoEventoPlanilla, TipoEventoPlanillaJSON } from './TipoEventoPlanilla';
export class TipoEventoPlanillaSystem {
  private readonly base = '/tipoeventoplanillas';
  constructor(private requestHandler: XhrRequestHandler) {}

  async getTipoEventoPlanillaIdentifiedBy(id: string): Promise<TipoEventoPlanilla> {
    const data = await this.requestHandler.get<TipoEventoPlanillaJSON>(`${this.base}/${id}`);
    return TipoEventoPlanilla.fromJSON(data);
  }

  async getList(): Promise<TipoEventoPlanilla[]> {
    const data = await this.requestHandler.get<TipoEventoPlanillaJSON[]>(`${this.base}`);
    return data.map((entity) => TipoEventoPlanilla.fromJSON(entity));
  }

  async getListForDropdown(): Promise<TipoEventoPlanilla[]> {
    const data = await this.requestHandler.get<TipoEventoPlanillaJSON[]>(`${this.base}/for-dropdown`);
    return data.map((entity) => TipoEventoPlanilla.fromJSON(entity));
  }

  async save(entity: TipoEventoPlanilla) {
    const data = entity.toJSON();
    const savedEntity = await this.requestHandler.post<TipoEventoPlanillaJSON, TipoEventoPlanillaJSON>(
      this.base,
      data
    );
    return TipoEventoPlanilla.fromJSON(savedEntity);
  }

  getBaseUrlForDatagrid() {
    return this.requestHandler.requestUrl(`${this.base}/datagrid`);
  }
}
